import React, { useMemo } from "react";
import Slide from "@mui/material/Slide";

/**
 * Dialog 的上下左右滑入/滑出轉場 hook
 * @param {"left"|"right"|"up"|"down"} enterDirection 滑入方向
 * @param {"left"|"right"|"up"|"down"} [exitDirection] 滑出方向，不填則等於滑入方向
 * @returns {any} TransitionComponent 給 MUI Dialog 使用
 */
const useDialogSlideTransition = (enterDirection = "up", exitDirection = null) => {
	return useMemo(() => {
		const SlideComponent = /** @type {any} */ (Slide);
		const TransitionComponent = React.forwardRef(function TransitionComponent(props, ref) {
			const { in: inProp } = /** @type {any} */ (props);
			const direction = inProp ? enterDirection : exitDirection ?? enterDirection;
			return <SlideComponent direction={direction} ref={ref} {...props} />;
		});
		return /** @type {any} */ (TransitionComponent);
	}, [enterDirection, exitDirection]);
};

export default useDialogSlideTransition;

